import { Button, Typography } from '@mui/material';
import Grid from '@mui/material/Grid';

import type { BulkActionsToolbarProps } from './BulkActionsToolbar.types';

/**
 * Toolbar displayed when cloud sources are selected for bulk activation/deactivation.
 * Shows selected count, action button, and cancel button.
 *
 * @component
 * @example
 * ```tsx
 * <BulkActionsToolbar
 *   count={5}
 *   actionLabel="Activate"
 *   onActivateDeactivate={handleActivate}
 *   onCancelSelection={handleCancel}
 *   gridRef={gridRef}
 * />
 * ```
 */
const BulkActionsToolbar = ({
  count,
  actionLabel,
  onActivateDeactivate,
  onCancelSelection,
  gridRef
}: BulkActionsToolbarProps) => {
  return (
    <Grid
      sx={{
        maxHeight: '1.8rem'
      }}
      container
      spacing={2}
    >
      <Typography sx={{ alignContent: 'center' }}>
        <span>{count}</span> Selected
      </Typography>

      <Button
        variant="contained"
        onClick={onActivateDeactivate}
        disabled={count === 0}
      >
        {actionLabel}
      </Button>

      <Button variant="outlined" onClick={() => onCancelSelection(gridRef)}>
        Cancel
      </Button>
    </Grid>
  );
};

export default BulkActionsToolbar;
